// @flow
import React from 'react';
import { Container, Row, Col } from 'Components/Grid';
import Icon from 'Components/Icon';
import ConsumptionData from 'Components/ConsumptionData';
import styles from './deprecated.scss';
import classNames from 'classnames/bind';
import { getGivenBackground } from 'Utils/getColor';
import CallToAction from 'Components/CallToAction';

const cx = classNames.bind(styles);

type Props = {
  background: String,
  align: String,
  headline?: String,
  cols: Array<Object>,
  deeplinkId?: number,
};

export default class GridContentBoxDeprecated extends React.Component<Props> {
  render() {
    const { background, headline, cols, align, deeplinkId, consumptionText, cta } = this.props;
    const colSize = 12 / cols.length;

    const containerClass = cx('container', {
      [background]: true,
      overwriteFonts: background === getGivenBackground('black'),
    });

    return (
      <div className={containerClass} id={deeplinkId}>
        <Container>
          {headline && (
            <Row align="center">
              <Col cols={12} m={10} l={8} className={styles.col}>
                <h3 className={styles.headline} dangerouslySetInnerHTML={{ __html: headline }} />
              </Col>
            </Row>
          )}
          <Row>
            {cols.map((col, i) => (
              <Col
                key={'col' + i}
                cols={12}
                m={colSize}
                className={styles.col}
                stretch
                valign={align === 'center' || align === 'bottom' ? align : undefined}
              >
                <div className={styles.contentBox}>
                  {col.icon && (
                    <div className={styles.icon}>
                      <Icon name={col.icon} inline={false} />
                    </div>
                  )}
                  {col.headline && <h4 dangerouslySetInnerHTML={{ __html: col.headline }} />}
                  {col.text && (
                    <div className={styles.text} dangerouslySetInnerHTML={{ __html: col.text }} />
                  )}
                </div>
              </Col>
            ))}
          </Row>
          {cta && cta.label && cta.href && (
            <div className={styles.cta}>
              <CallToAction {...cta} />
            </div>
          )}
        </Container>
        {consumptionText && <ConsumptionData consumptionText={[consumptionText]} />}
      </div>
    );
  }
}
